angular.module('FlexyBeautyApp.services').
    factory('Slack_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/slack',{}, {});
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Slack',["Slack_Resource", function (Slack_Resource)
    {
        var  Slack = function (resource)
        {
            this.message = null;
        }

     Slack.prototype.getObjectResource = function()
            {
                var rsSlack = new Slack_Resource();
                rsSlack.message = this.message;
                return rsSlack;
            }
        return Slack;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SlackSrv',["$log","Slack_Resource","Slack","ServerSrv",
        function ($log,Slack_Resource,Slack,ServerSrv)
        {
        var  slackSrv = {};

        slackSrv.sendMessage = function(message, successFunction,errorFunction)
        {
            var slack = new Slack();
            slack.message = message;
            ServerSrv.startSavingProcess(slackSrv.saveSync, slack, successFunction, errorFunction);
        };
        slackSrv.save = function(slack,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(slackSrv.saveSync, slack, successFunction, errorFunction);
        };
        slackSrv.saveSync = function(slack,successFunction,errorFunction)
        {
            //$timeout (function () {

            var SlackRes = slack.getObjectResource();
            SlackRes.$save({}, //no params
                function (data) {
                    try{
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        return slackSrv;
    }
    ]);




// WEBPACK FOOTER //
// ./js/services/models/Slack.js